import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-transaction-shell',
  templateUrl: './transaction-shell.component.html',
  styleUrls: ['./transaction-shell.component.less'],
  standalone: false,
})
export class TransactionShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
